import React, { Component } from 'react';
import renderHTML from 'react-render-html';

import MediaQuery from 'react-responsive';
import Author from '../Author/Author';


import classes from './Summary.module.scss';

class Summary extends Component {

    render(){
        return (
            <div className={classes['summary']}>
                <p className={classes.summary__text}>{renderHTML(this.props.content.text)}</p>
                <div className={classes.summary__border}></div>

                <MediaQuery maxWidth={classes.screenMaxXl}>
                    {(this.props.summaryIndex === 0 ? <Author content={this.props.authorID} /> : null)}
				</MediaQuery>
            
            </div>

        );
    }
}

export default Summary;